module.exports = __webpack_public_path__ + "img/select-light-01.454c02fa.png";